import { ReorderChangeLocationScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ReorderChangeLocationScreen />;
}
